<div class="wrapper-page-about">
  <div class="bg-about-page"> </div>
  <div class="zc-container">
    <div class="grid">
      <div class="grid__l-6">
        <div class="wrapper-description-about">
          <span class="title-about-page">{{'GLOBAL.about_us' | translate}}</span>
          <span class="description-about-page">
          {{'ABOUT.welcome_to_my_birthday_the_first_application_that_allows_parents_to_organize_a_complete_childs_birthday_in_one_place' | translate}}<br>
          {{'ABOUT.our_mission_is_to_make_planning_celebrations_simple_fast_and_stress_free_no_calls_and_no_appointments_just_a_few_clicks' | translate}}<br>
            {{'ABOUT.you_can_book_everything_you_need_in_the_app' | translate}}<br>
            {{'ABOUT.in_addition_to_your_organization_moj_rodjendan_also_brings_a_wish_list_of_gifts_so_that_guests_know_exactly_what_the_child_wants' | translate}}<br>
            {{'ABOUT.join_us_and_make_every_birthday_magical_simple_and_unforgettable' | translate}}<br>
            {{'ABOUT.available_on_app_store_and_google_play' | translate}}
          </span>
          <div class="wrapper-logo-about">
            <img src="../../../../assets/images/landing/logo-about-page.svg" alt="">
          </div>
        </div>
      </div>
      <div class="grid__l-6">
        <!-- Photo Grid -->
        <div class="gallery">
          <figure *ngFor="let image of gallery; index as imageIndex" (click)="handleShowCarousel(imageIndex)">
            <img [src]="image.full_path" alt="">
          </figure>
        </div>
      </div>
      <div *ngIf="showCarousel" class="wrapper-carousel-slider">
        <div class="wrapper-content-carousel-slider">
          <div class="wrapper-btn-carousel-close">
            <button class="btn-carousel-close" (click)="showCarousel = false">
              <span>{{'ABOUT.close' | translate}}</span>
              <img src="../../../../assets/icons/landing/icon-close.svg" alt="">
            </button>
          </div>
          <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
            <div ngxSlickItem *ngFor="let slide of gallery" class="slide">
              <img src="{{ slide.full_path }}" alt="slide">
            </div>
          </ngx-slick-carousel>
          <div (click)="slickModal.slickPrev()" class="wrapper-arrow-prev">
            <img src="../../../../assets/icons/landing/icon-arrow-left-slider.svg" alt="">
          </div>
          <div (click)="slickModal.slickNext()" class="wrapper-arrow-next">
            <img src="../../../../assets/icons/landing/icon-arrow-right-slider.svg" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
